import blob from '../../../helpers/blob';
import downcaseKeys from '../../../helpers/downcaseKeys';
import serialiseError from '../../../helpers/serialiseError';
import axiosErrorResponse from '../../../helpers/axiosErrorResponse';

/**
 * Convert from a number of possibilities to a log entry object
 * @param  {Object|String|Error} data
 * @param  {Object} details
 * @return {Object}
 */
export default function serialise(data, details = {}) {
    if (!data || typeof data === 'string') {
        return Object.assign({ message: data }, downcaseKeys(details));
    }

    if (typeof data === 'object') {
        const { isAxiosError } = data;

        // toJSON should be applied before stringifying objects
        if (typeof data.toJSON === 'function') {
            data = data.toJSON();
        }

        // Axios specific handling
        if (isAxiosError) {
            if (data.config && typeof data.config === 'object') {
                data.config = blob(data.config);
            }
            if (data.response) {
                data.response = axiosErrorResponse(data);
            }
        }
    }

    if (data instanceof Error) {

        // @hapi/joi validation error
        if (data.name === 'ValidationError' && typeof data._original === 'object') {

            // Details is an array of objects
            data.details = {
                issues: JSON.stringify(data.details),
                original: JSON.stringify(data._original)
            };

            delete data._original;
        }

        return downcaseKeys(
            serialiseError(data, details)
        );
    }

    return Object.assign(...[data, details].map(downcaseKeys));
}
